// components/common/Player.js

import React from 'react';
import { useApp } from '../../context/AppContext';

const Player = () => {
  const { 
    currentTrack, 
    isPlaying, 
    playerState, 
    playTrack 
  } = useApp();

  if (!currentTrack) return null;

  const { position, duration } = playerState;
  const progress = duration ? (position / duration) * 100 : 0;

  return (
    <div className="player">
      <div className="player-content">
        {/* Track Info */}
        <div className="track-info">
          <img
            src={currentTrack.album?.images?.[2]?.url}
            alt={currentTrack.name}
            className="track-image"
          />
          <div className="track-details">
            <span className="track-name">{currentTrack.name}</span>
            <span className="track-artist">
              {currentTrack.artists?.[0]?.name}
            </span>
          </div>
        </div>

        {/* Player Controls */}
        <div className="player-controls">
          <div className="progress-bar">
            <div 
              className="progress"
              style={{ width: `${progress}%` }}
            />
          </div>
          <div className="controls-buttons">
            <button
              className="control-btn"
              onClick={() => playTrack(currentTrack)}
            >
              <i className={`bi bi-${isPlaying ? 'pause' : 'play'}-fill`} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Player;